module.exports = __webpack_public_path__ + "static/media/OMERS-logo.10365cc6.png";